<div class="feedback-fab" [class.disabled]="disabled()" [class.label-on-hover]="showLabelOnHover()">
  <button type="button" class="fab-trigger" [disabled]="disabled()" (click)="onClick()" aria-label="Abrir feedback">
    <span class="feedback-txt">Feedback</span>
    <span class="icon-like" aria-hidden="true"></span>
  </button>
</div>
